import { useFieldArray } from "react-final-form-arrays";

export function ProductsTable({ name, slots = {} }) {
    const requests = useFieldArray(name);

    return (
        <div className="flex items-start w-full gap-4">
            <table className="flex-1">
                <thead>
                    <tr>
                        <th className="text-left">Request Type</th>
                        <th className="text-left">Serial number</th>
                        <th className="text-left">Product</th>
                        <th className="text-left">Problem</th>
                        <th className="text-left">Warranty</th>
                    </tr>
                </thead>
                <tbody>
                    {requests.fields.value?.map((request, index) => (
                        <tr key={index}>
                            <td>Warranty</td>
                            <td>123456</td>
                            <td>Product 1</td>
                            <td>Problem 1</td>
                            <td>Yes</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {slots.addButton && <slots.addButton />}
        </div>
    );
}
